import { Input } from '@/components/core/input';
import { useDebouncedControlledState } from '@/shared/hooks/use-debounced-controlled-state';

type Props = {
  value: string;
  onChange: (value: string) => void;
};

export function DataTableSearchInput({ value: valueProp, onChange }: Props) {
  const [value, setValue] = useDebouncedControlledState({ value: valueProp, onChange });
  return (
    <Input
      aria-label="search"
      className="h-8 w-40 lg:w-56"
      value={value}
      onChange={(e) => setValue(e.target.value)}
      placeholder="Search..."
      type="search"
    />
  );
}
